import {
    convertToBusinessAreasWithServices,
    convertToService
} from 'actions/services/ServicesConverter';
import { BusinessAreasWithServicesDto, ServiceDto } from 'actions/services/ServicesDtos';
import { ApiPublicClient } from 'api/ApiClient';
import { AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { BusinessAreasWithServices, Service } from 'types/Service';
import {
    BUSINESS_AREAS_ERROR_ACTION_TYPE,
    BUSINESS_AREAS_FETCH_ACTION_TYPE,
    BUSINESS_AREAS_FETCH_SUCCESS_ACTION_TYPE,
    SERVICES_ERROR_ACTION_TYPE,
    SERVICES_FETCH_ACTION_TYPE,
    SERVICES_FETCH_SUCCESS_ACTION_TYPE,
    ServicesAction
} from './ServicesActionsTypes';

const servicesUrl = '/olb_services_lookup';

const errorHandler = (error: unknown): ServicesAction => {
    console.error(error);

    return {
        type: SERVICES_ERROR_ACTION_TYPE
    };
};

export const fetchServicesThunk = (
    marketplaceId: number
): ThunkAction<Promise<Array<Service>>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch({
            type: SERVICES_FETCH_ACTION_TYPE
        });

        try {
            const { data }: AxiosResponse<Array<ServiceDto>> = await ApiPublicClient.get(
                servicesUrl,
                {
                    params: {
                        marketplace_id: marketplaceId
                    }
                }
            );

            const services = data.map(service => convertToService(service));

            dispatch({
                type: SERVICES_FETCH_SUCCESS_ACTION_TYPE,
                payload: {
                    services
                }
            });

            return services;
        } catch (error) {
            dispatch(errorHandler(error));

            throw error;
        }
    };
};

export const fetchBusinessAreasWithServicesThunk = (
    marketplaceId: number
): ThunkAction<Promise<Array<BusinessAreasWithServices>>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch({
            type: BUSINESS_AREAS_FETCH_ACTION_TYPE
        });

        try {
            const { data }: AxiosResponse<Array<BusinessAreasWithServicesDto>> =
                await ApiPublicClient.get('/business_areas_with_services', {
                    params: {
                        marketplace_id: marketplaceId
                    }
                });

            const areas = data.map(area => convertToBusinessAreasWithServices(area));

            dispatch({
                type: BUSINESS_AREAS_FETCH_SUCCESS_ACTION_TYPE,
                payload: {
                    areas
                }
            });

            return areas;
        } catch (error) {
            console.error(error);

            dispatch({
                type: BUSINESS_AREAS_ERROR_ACTION_TYPE
            });

            return [];
        }
    };
};
